export default __webpack_public_path__ + "static/media/failure.177fb7e5.png";